<template>
  <section class="searchbar  w-full h-34px opacity-50 p-s	relative  bg-white flex items-center">
    <input type="text" 
      class="h-full bg-transparent focus:outline-none" 
      placeholder="Buscar cursos" 
      v-model="key_code"
      @keyup.enter="searchCourses"
    />
    <div @click="searchCourses">
      <Search />
    </div>
  </section>
</template>

<script>
import Search from "./icons/Search.vue";
export default {
  components: { Search },
  data() {
    return {
      key_code: "",
    };
  },
  methods:{
    searchCourses() {
      this.$router.push({ 
        name: "v2-categories", 
        query: {
          q: this.key_code,
        }
      });
    }
  }
};
</script>